<template>
    <div>
        <p class="title">填报申请信息</p>
        <van-cell-group>
            <van-field required label="单位名称" v-model="company.dwmc" placeholder="请输入单位名称"
                       input-align="right"/>
            <van-field required readonly clickable label="社保缴纳情况" v-model="company.sbjnqkmc" placeholder="请选择"
                       @click="showPicker = true" input-align="right" is-link/>
            <van-popup v-model="showPicker" position="bottom">
                <van-picker show-toolbar :columns="list" value-key="name" @cancel="showPicker = false"
                            @confirm="onConfirmQK"/>
            </van-popup>
            <van-field required label="纳税情况" input-align="right" type="textarea" v-model="company.nsqk"
                       placeholder="请输入纳税情况" rows="1" autosize clearable/>
            <!--单位地址-->
            <van-field v-model="company.dwdz1" label="单位地址:" placeholder="请选择省份" is-link required readonly
                       input-align="right"
                       @click="showPickerProvince = true"/>
            <van-popup v-model="showPickerProvince" position="bottom">
                <van-picker :columns="provinceList" show-toolbar value-key="title"
                            @cancel="showPickerProvince = false"
                            @confirm="onConfirmProvince"/>
            </van-popup>
            <van-field v-model="company.dwdz2" placeholder="请选择市区" is-link readonly input-align="right"
                       @click="showPickerCity = true" v-if="cityShow"/>
            <van-popup v-model="showPickerCity" position="bottom">
                <van-picker :columns="cityList" show-toolbar value-key="title" @cancel="showPickerCity = false"
                            @confirm="onConfirmCity"/>
            </van-popup>
            <van-field v-model="company.dwdz3" placeholder="请选择区县" is-link readonly input-align="right"
                       @click="showPickerArea = true" v-if="areaShow"/>
            <van-popup v-model="showPickerArea" position="bottom">
                <van-picker :columns="areaList" show-toolbar value-key="title" @cancel="showPickerArea = false"
                            @confirm="onConfirmArea"/>
            </van-popup>
            <van-field input-align="right" type="textarea" v-model="company.dwdzxxdz"
                       placeholder="请输入区划内详细地址" rows="1" autosize clearable/>
            <van-field input-align="right" label="所属派出所:" type="textarea" required v-model="company.jcysspcs"
                       placeholder="请输入所属派出所" rows="1" autosize clearable/>
        </van-cell-group>
    </div>
</template>

<script>
    import {Button, Toast, CellGroup, Field, Dialog, Popup, Picker, DatetimePicker, RadioGroup, Radio} from 'vant'
    import {dateToString} from '@/utils/time'
    import {baseApiMap} from '@/api/base'
    import {forEachObj} from '@/utils/check'

    export default {
        components: {
            [Button.name]: Button,
            [Toast.name]: Toast,
            [CellGroup.name]: CellGroup,
            [Field.name]: Field,
            [Dialog.name]: Dialog,
            [Popup.name]: Popup,
            [Picker.name]: Picker,
            [DatetimePicker.name]: DatetimePicker,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio
        },
        props: {
            companyInfo: {
                type: Object,
                default: () => ({})
            },
        },
        data() {
            return {
                company: {
                    dwmc: '',
                    sbjnqk: '',
                    nsqk: '',
                    dwdz1: '',
                    dwdz2: '',
                    dwdz3: '',
                    dwdzxxdz: '',
                    jcysspcs: '',
                },
                list: [{key: '已缴纳', name: '已缴纳'}, {key: '未缴纳', name: '未缴纳'}], // 社保缴纳情况列表
                showPicker: false, // 是否显示社保缴纳情况选择框
                provinceList: [], // 省
                cityList: [], // 户籍市
                areaList: [], // 户籍区县
                showPickerProvince: false, // 是否显示单位地址省选择框
                cityShow: false, // 是否显示单位地址市
                areaShow: false, // 是否显示单位地址区县
                showPickerCity: false, // 是否显示单位地址市选择框
                showPickerArea: false, // 是否显示单位地址区县选择框
            }
        },
        mounted() {
            this.getProvinceData()
        },
        methods: {

            /**
             * 获取省
             */
            async getProvinceData() {
                try {
                    const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + 0)
                    let arr = [];
                    if (res.data.succ = true) {
                        let d = res.data.data
                        for (let i = 0; i < d.length; i++) {
                            arr.push({"title": d[i].regionname, "val": d[i].regioncode})
                        }
                    }
                    this.provinceList = arr
                } catch (error) {
                    Toast('服务器运行失败')
                    console.log(error);
                }
            },
            /**
             * 获取市
             */
            async getCityData(value) {
                try {
                    this.cityList = []
                    this.areaList = []
                    const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + value);
                    let arr = [];
                    if (res.data.succ = true) {
                        let d = res.data.data
                        for (let i = 0; i < d.length; i++) {
                            arr.push({"title": d[i].regionname, "val": d[i].regioncode})
                        }
                    }
                    this.cityList = arr
                    if (this.cityList.length > 0) {
                        this.cityShow = true
                    } else {
                        this.cityShow = false
                    }
                } catch (error) {
                    Toast('服务器运行失败');
                    console.log(error);
                }
            },
            /**
             * 获取地区
             */
            async getAreaData(value) {
                try {
                    this.areaList = []
                    const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + value);
                    let arr = [];
                    if (res.data.succ = true) {
                        let d = res.data.data
                        for (let i = 0; i < d.length; i++) {
                            arr.push({"title": d[i].regionname, "val": d[i].regioncode})
                        }
                    }
                    this.areaList = arr
                    if (this.areaList.length > 0) {
                        this.areaShow = true
                    } else {
                        this.areaShow = false
                    }
                } catch (error) {
                    Toast('服务器运行失败');
                    console.log(error);
                }
            },
            /**
             * 选择社保缴纳情况
             */
            onConfirmQK(value) {
                this.company.sbjnqkmc = value.name
                this.company.sbjnqk = value.key
                this.showPicker = false
            },
            /**
             * 选择户籍地址省
             */
            onConfirmProvince(value) {
                this.company.dwdz1 = value.title
                this.company.dwdz2 = ''
                this.company.dwdz3 = ''
                this.showPickerProvince = false
                this.getCityData(value.val)
            },
            /**
             * 选择户籍地址市
             */
            onConfirmCity(value) {
                this.showPickerCity = false
                this.company.dwdz2 = value.title
                this.company.dwdz3 = ''
                this.getAreaData(value.val)
            },
            /**
             * 选择户籍区县
             */
            onConfirmArea(value) {
                this.showPickerArea = false
                this.company.dwdz3 = value.title
            },
            /**
             * 校验数据
             */
            validCompanyInfo1() {
                forEachObj(this.company) // 去掉空格
                if (!this.company.dwmc) {
                    Toast('请输入单位名称')
                    this.$emit('getCompanyInfo', false)
                    return
                }
                if (!this.company.sbjnqk) {
                    Toast('请选择社保缴纳情况')
                    this.$emit('getCompanyInfo', false)
                    return
                }
                if (!this.company.nsqk) {
                    Toast('请输入纳税情况')
                    this.$emit('getCompanyInfo', false)
                    return
                }
                if (!this.company.dwdz3) {
                    Toast('请选择单位地址')
                    this.$emit('getCompanyInfo', false)
                    return
                }
                if (!this.company.dwdzxxdz) {
                    Toast('请输入单位区划内详细地址')
                    this.$emit('getCompanyInfo', false)
                    return
                }
                if (!this.company.jcysspcs) {
                    Toast('请输入所属派出所')
                    this.$emit('getCompanyInfo', false)
                    return
                }

                // 单位名称
                this.companyInfo.dwmc = this.company.dwmc
                // 社保缴纳情况
                this.companyInfo.sbjnqk = this.company.sbjnqk
                // 纳税情况
                this.companyInfo.nsqk = this.company.nsqk
                // 单位地址
                this.companyInfo.dwdz = this.company.dwdz1 + this.company.dwdz2 + this.company.dwdz3 + this.company.dwdzxxdz
                // 单位所属派出所
                this.companyInfo.sspcs = this.company.jcysspcs

                this.$emit('getCompanyInfo', true)
                return
            }
        }
    }
</script>

<style lang="less" scoped>
    .title {
        padding: 0.3rem;
        color: #808080;
    }
</style>